<template>
  <div>

    <el-row>
      <!-- <el-col :span="16" :offset="6"> -->
      <el-col :span="24" >
        <div>
          <el-container>
            <el-header style="height:0px;">
            </el-header>
            <el-container>
              <el-aside style="width:0px;">
                <el-row>
                  <el-col>
                    <el-menu router :default-active=$route.path class="el-menu-vertical-demo" @open="handleOpen" @close="handleClose">
                      
                    </el-menu>
                  </el-col>
                </el-row>

              </el-aside>
              <el-main>

                <router-view></router-view>
              </el-main>
            </el-container>
          </el-container>
        </div>
      </el-col>
    </el-row>

  </div>

</template>
<script>
export default {
  data() {
    return {
      isCollapse: true,
      
    };
  },
  methods: {
    handleOpen(key, keyPath) {
      console.log(key, keyPath);
    },
    handleClose(key, keyPath) {
      console.log(key, keyPath);
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Common/UserCenter.vue